const guiColors = {
    'motion-primary': '#00c4ff',
    'motion-primary-transparent': '#00c4ffe6',
    'motion-tertiary': '#007bc7',

    'looks-secondary': '#00c4ff',
    'looks-secondary-light': '#5EDAFF',
    'looks-secondary-lighter': '#94E6FF',
    'looks-transparent': '#00c4ffe6',
    'looks-light-transparent': 'hsla(203, 100%, 39%, 0.15)',
    'looks-secondary-dark': '#009CCC',
    'looks-secondary-darker': '#006994',
    'looks-secondary-deep-dark': '#004970',

    'extensions-primary': 'hsla(194, 100%, 58%, 1)',
    'extensions-tertiary': 'hsla(194, 100%, 35%, 1)',
    'extensions-transparent': 'hsla(194, 100%, 58%, 0.43)',
    'extensions-light': 'hsla(194, 100%, 75%, 1)',

    'drop-highlight': '#64caf5'
};

const blockColors = {
    checkboxActiveBackground: '#00c4ff',
    checkboxActiveBorder: '#007CBD'
};

export {
    guiColors,
    blockColors
};